export default "<h1 mat-dialog-title>{{data.message}} </h1>"